const isNameValid = (name) => {
	return name && name.length >= 2;
};

export default isNameValid;